import popover from "./index.vue";

// 添加install方法 （插件方法）
const Popover = {
  install: function (Vue) {
    Vue.component("Popover", popover);
  },
};

export default Popover;
